import { Form, Formik } from "formik";
import {
  APPLY_BUTTON_STYLE,
  RESET_BUTTON_STYLE,
  getTodayEndDateTime,
} from "./reportCommon";
import { DEFAULT_OVERVIEW_SECONDARY_COLLECTION_FILTERS } from "./staticReportData";

const OverviewSecondaryCollectionPointFilter = ({
  initialValues = DEFAULT_OVERVIEW_SECONDARY_COLLECTION_FILTERS,
  onSearch,
  onReset,
}) => (
  <Formik
    initialValues={initialValues}
    enableReinitialize
    onSubmit={(values) => onSearch?.(values)}
  >
    {({ values, setFieldValue, resetForm, handleSubmit }) => (
      <Form onSubmit={handleSubmit}>
        <div className="row align-items-end">
          <div className="col-md-3 mb-3">
            <label className="form-label">From Date &amp; Time</label>
            <input
              type="datetime-local"
              name="fromDate"
              value={values.fromDate}
              max={getTodayEndDateTime()}
              onChange={(event) =>
                setFieldValue("fromDate", event.target.value)
              }
              className="form-control bg-white"
            />
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">To Date &amp; Time</label>
            <input
              type="datetime-local"
              name="toDateTime"
              value={values.toDate}
              min={values.fromDate || undefined}
              max={getTodayEndDateTime()}
              onChange={(event) =>
                setFieldValue("toDate", event.target.value)
              }
              className="form-control bg-white"
            />
          </div>

          <div className="col-md-3 mb-3 d-flex gap-2">
            <button type="submit" style={APPLY_BUTTON_STYLE}>
              APPLY FILTERS
            </button>
            <button
              type="button"
              style={RESET_BUTTON_STYLE}
              onClick={() => {
                resetForm({
                  values: DEFAULT_OVERVIEW_SECONDARY_COLLECTION_FILTERS,
                });
                onReset?.();
              }}
            >
              RESET
            </button>
          </div>
        </div>
      </Form>
    )}
  </Formik>
);

export default OverviewSecondaryCollectionPointFilter;
